import React from "react";

interface RouterItem {
    path: string;
    component: any;
    exact?: boolean;
    isNotPrivate?: boolean;
    isDebug?: boolean;
}

// const LoginModule = React.lazy(() => import("../pages/login"));
const RegisterModule = React.lazy(() => import("../pages/register"));
const DashboardModule = React.lazy(() => import("../pages/dashboard"));
const MainViewerModule = React.lazy(() => import("../pages/main-viewer"));
const MainViewerSdkModule = React.lazy(
    () => import("../pages/main-viewer-sdk")
);
const IconPreview = React.lazy(() => import("../components/IconPreview"));
const TestViewerModule = React.lazy(() => import("../pages/test-viewer"));

const RouterArr: RouterItem[] = [
    {
        path: "/",
        component: DashboardModule,
        exact: true,
        isNotPrivate: true,
    },
    // {
    //     path: "/login",
    //     component: LoginModule,
    //     exact: true,
    //     isNotPrivate: true
    // },
    {
        path: "/register",
        component: RegisterModule,
        exact: true,
        isNotPrivate: true,
    },
    {
        path: "/open",
        component: DashboardModule,
        exact: true,
        isNotPrivate: true,
    },
    {
        path: "/mainviewer",
        component: MainViewerModule,
        exact: true,
        isNotPrivate: true,
    },
    {
        path: "/mainviewer-sdk",
        component: MainViewerSdkModule,
        exact: true,
        isNotPrivate: true,
    },
    {
        path: "/icons",
        component: IconPreview,
        exact: true,
        isNotPrivate: true,
    },
    {
        path: "/test-viewer",
        component: TestViewerModule,
        exact: true,
        isNotPrivate: true,
        isDebug: true,
    },
];

export default RouterArr;
